import React from "react";
import { sanitizeRichHtml } from "@v0y4ge/html-safe";
const SOCIAL_GLYPHS: Record<string, string> = {twitter:"X",facebook:"f",instagram:"◎",linkedin:"in"};

export function AppointmentFooter({ footer, showCustom, hideJrni }: {
  footer?: { mode?: string; text?: string; html?: string; showJrni?: boolean; socials?: Record<string, boolean> };
  showCustom: boolean;
  hideJrni?: boolean;
}) {
  if (!showCustom) return null;
  const custom = footer ?? {};
  const html = custom.mode === "html" ? sanitizeRichHtml(custom.html ?? "") : "";
  const text = (!custom.mode || custom.mode === "text") ? custom.text : "";
  const socials = custom.mode === "socials"
    ? ["twitter", "facebook", "instagram", "linkedin"].filter(key => custom.socials?.[key]) : [];
  const credit = custom.showJrni !== false && !hideJrni
    && (custom.mode === "socials" || ((!custom.mode || custom.mode === "text") && !text));
  if (!html && !text && !socials.length && !credit) return null;
  return <footer data-appointment-footer="" style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", padding: "14px 24px", borderTop: "1px solid var(--jrni-color-surface-border)", background: "var(--jrni-color-neutral-6)", fontSize: 12, color: "var(--jrni-color-text-soft)" }}>
    {html ? <div data-appointment-custom-footer="" dangerouslySetInnerHTML={{ __html: html }} /> : null}
    {text ? <span data-appointment-custom-footer="">{text}</span> : null}
    {socials.length ? <span data-appointment-custom-footer="">{socials.map(key => <span key={key} aria-label={key} style={{ marginRight: 12 }}>{SOCIAL_GLYPHS[key]}</span>)}</span> : null}
    {credit ? <span data-appointment-footer-credit="">Powered by JRNI</span> : null}
  </footer>;
}
